<template>
    <v-app>
        <v-toolbar app>
            <img src="http://lavprislaase.dk/ruko_kode/logony.jpg" alt="" style="max-height:100%;">
        </v-toolbar>

        <v-content>
            <RukoGarantTen v-if="bottomNav == 'ten'" key="ten"></RukoGarantTen>
            <RukoGarantPlus v-if="bottomNav == 'plus'" key="plus"></RukoGarantPlus>
            <RukoGarantD12 v-if="bottomNav == 'd12'" key="d12"></RukoGarantD12>
        </v-content>

        <v-footer app>

        <v-bottom-nav
                :active.sync="bottomNav"
                :value="true"
                absolute
                color="transparent"
        >
            <v-btn
                    color="teal"
                    flat
                    value="ten"
            >
                <span>Garant 10</span>
                <v-icon>vpn_key</v-icon>
            </v-btn>

            <v-btn
                    color="teal"
                    flat
                    value="plus"
            >
                <span>Garant Plus</span>
                <v-icon>vpn_key</v-icon>
            </v-btn>

            <v-btn
                    color="teal"
                    flat
                    value="d12"
            >
                <span>D12 1200 Series</span>
                <v-icon>vpn_key</v-icon>
            </v-btn>

        </v-bottom-nav>
        </v-footer>

    </v-app>
</template>

<script>
    import RukoGarantTen from './components/RukoGarantTen'
    import RukoGarantPlus from './components/RukoGarantPlus'
    import RukoGarantD12 from './components/RukoGarantD12'

    export default {
        name: 'RukoDecoder',
        data() {
            return {
                bottomNav: 'ten',
            }
        },
        components: {
            RukoGarantTen,
            RukoGarantPlus,
            RukoGarantD12,
        },
    }
</script>


<style>
    .v-content{
        padding: 65px 0 !important;
    }
    .v-toolbar__content {
        display: flex;
        justify-content: center;
        padding: 5px 0;
    }
    .v-footer{
        height: 56px !important;
    }

    input[type='text'] {
        font-size: 32px;
        max-height: unset;
        text-align: center;
        letter-spacing: 5px;
    }
</style>